import moment from 'moment-timezone';

function formatTime(organization, time) {
  return moment(time).tz(organization.timezone).toISOString().replace(/-|:|\.\d+/g, '');
}

function organizationTitle(organization) {
  return (organization && organization.title && organization.title[organization.locale]) || '';
}

function location(organization) {
  return (organization && organization.address && organization.address.formatted) || '';
}

function generateEvent(reservation, organization) {
  return {
    organizationTitle: organizationTitle(organization),
    startTime: formatTime(organization, reservation.time),
    endTime: formatTime(organization, reservation.time + (1000 * 60 * 60 * 2)),
    details: '',
    location: location(organization)
  };
}

export function generateGoogleHref(reservation, organization) {
  const {organizationTitle, startTime, endTime, details, location} = generateEvent(reservation, organization);
  return {
    href: encodeURI(`https://www.google.com/calendar/render?action=TEMPLATE&text=${organizationTitle}&dates=${startTime}/${endTime}&details=${details}&location=${location}`),
    target: '_blank'
  };
}

export function generateIcsHref(reservation, organization) {
  const {organizationTitle, startTime, endTime, details, location} = generateEvent(reservation, organization);
  return {
    href: encodeURI(`data:text/calendar;charset=utf8,BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nDTSTART:${startTime}\nDTEND:${endTime}\nSUMMARY:${organizationTitle}\nDESCRIPTION:${details}\nLOCATION:${location}\nEND:VEVENT\nEND:VCALENDAR\n`),
    download: organizationTitle + '.ics'
  };
}

export default function generateAddToCalendarHref(reservation, organization, type) {
  switch (type) {
    case 'google':
      return generateGoogleHref(reservation, organization);
    case 'ical':
    case 'outlook':
      return generateIcsHref(reservation, organization);
    default:
      return {href: ''};
  }
}



// WEBPACK FOOTER //
// ./utils/calendarUtils.js